import React from "react";
import { NavLink, Link, withRouter } from "react-router-dom";
import NavItem from "./NavItem";
import logo from "../../logo.png";
import FixedNav from "./FixedNav";
import UpperInfo from "./UpperInfo";
import Burger from "react-icons/lib/md/format-list-bulleted";

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTopClass: "fixed-nav visuallyhidden",
      burgerClickClass: "visuallyhidden",
      width:window.innerWidth
    };
    this.onScroll = this.onScroll.bind(this);
  }

  onScroll() {
    if (document.documentElement.scrollTop > 96) {
      this.setState({
        scrollTopClass: " animated fadeInDown"
      });
    } else {
      this.setState({
        scrollTopClass: " visuallyhidden"
      });
    }
  }
  
  componentWillMount(){
   this.unlisten = this.props.history.listen((a,b)=>{
      this.setState({
        burgerClickClass: " visuallyhidden"
      });
    });
  }
  
  componentWillUnmount(){
    this.unlisten();
  }

  componentDidMount(){
    window.onresize =() => this.setState({width : window.innerWidth});
  }

  onMenuClick() {
    const changedClass =
      this.state.burgerClickClass === "visuallyhidden"
        ? " animated fadeIn"
        : "visuallyhidden";
    this.setState({ burgerClickClass: changedClass });
  }
  renderNormal() {
    return (
      <React.Fragment>
        <UpperInfo />
        <div className="nav-items wrapper">
          <Link to="/">
            <div className="fixed-logo">
              {" "}
              <img src={logo} alt="fixed-logo" />
            </div>
          </Link>
          <NavLink exact to="/" activeClassName="active" className="nav-item">
            <NavItem title="الرئيسية" />
          </NavLink>
          <NavLink to="/services" activeClassName="active" className="nav-item">
            <NavItem title="خدماتنا" />
          </NavLink>
          <NavLink to="/about" activeClassName="active" className="nav-item">
            <NavItem title="عن المركز" />
          </NavLink>
          <NavLink to="/contact" activeClassName="active" className="nav-item">
            <NavItem title="أتصل بنا" />
          </NavLink>
        </div>
        <div className={this.state.scrollTopClass + " fixed-cnt"}>
          <FixedNav scrollClasses={"fixed-nav wrapper"} />
        </div>
      </React.Fragment>
    );
  }

  renderResponsive() {
    return (
      <div className="fixed-cnt">
        <div className="responsive-nav">
          <div className="burger" onClick={this.onMenuClick.bind(this)}>
            <Burger />
          </div>
          <Link to="/">
            <div className="fixed-logo">
              {" "}
              <img src={logo} alt="fixed-logo" />
            </div>
          </Link>
        </div>
        <div className={this.state.burgerClickClass + " resposive-flex"}>
          <NavLink exact to="/" activeClassName="active" className="nav-item">
            <NavItem title="الرئيسية" />
          </NavLink>
          <NavLink to="/services" activeClassName="active" className="nav-item">
            <NavItem title="خدماتنا" />
          </NavLink>
          <NavLink to="/about" activeClassName="active" className="nav-item">
            <NavItem title="عن المركز" />
          </NavLink>
          <NavLink to="/contact" activeClassName="active" className="nav-item">
            <NavItem title="أتصل بنا" />
          </NavLink>
        </div>
      </div>
    );
  }

  render() {
    window.onscroll = () => this.onScroll();
    return (
      <header>
        {this.state.width > 850
          ? this.renderNormal()
          : this.renderResponsive()}
      </header>
    );
  }
}
export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/nav/Nav.js